<i18n src="./langs.yaml"></i18n>

<template>
  <section>
    <div v-if="isInited" class="init-container">
      <div class="identify__reslut__wrap">
        <!-- 标题 -->
        <div
          class="identify__title"
          :class="identifyResults.resultTitle.length > 9 ? 'over-font' : ''"
        >
          {{ identifyResults.resultTitle }}
        </div>
        <!-- 时间 -->
        <div class="identify__time">{{ beIdentifyProduct.formatTime }}</div>
        <!-- poizon -->
        <div class="identify__poizon__bg"></div>
        <!-- 鉴别结果得出官方文案 -->
        <div v-if="isNotRevoked" class="identify__authoritative__text">
          {{ $t('tip') }}
        </div>
        <!-- 结果的图片 -->
        <div class="checkup-results-tipimg">
          <img
            v-if="identifyResults.resultIcon"
            :src="identifyResults.resultIcon"
          />
          <div v-if="identifyResults.iconTip" class="text-container">
            <div class="text" :style="identifyResults.style">
              {{ identifyResults.iconTip }}
            </div>
          </div>
        </div>
        <!-- 问题列表 -->
        <div
          v-if="report.length && isShowproblem"
          class="identify__fail__reason"
        >
          <div class="identify__fail__problems">{{ $t('problem') }}</div>
          <div class="identify__fail__list">
            <div
              v-for="(item, index) in report"
              :key="index"
              class="identify__fail__item"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>

      <!-- 鉴别的图片 -->
      <div class="identify__product__title__image">
        <div class="identify__product__title">
          {{ beIdentifyProduct.title }}
        </div>
        <div class="identify__product__images">
          <img
            v-for="(img, index) in images"
            :key="index"
            :src="img | handleImage(800)"
            @click="seeContentImg(index)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import imgFilter from './filter'
import { Jockeys } from '@/utils'

export default {
  filters: {
    handleImage: imgFilter
  },
  data() {
    return {
      isInited: false,
      identifyResults: {},
      beIdentifyProduct: {},
      report: [],
      images: [], // 鉴别商品的图片
      isNotRevoked: true, // 不是撤销状态
      isShowproblem: false
    }
  },
  mounted() {
    window.Jockey.on('loadIdentifyDetailData', (payload, comment) => {
      const data = payload.data || payload
      this.isInited = true
      const { question, questionReason, images = [] } = data.detail

      // 鉴定结果标题和右上角的切片展示
      this.initRegularResult(question, questionReason)
      // 处理question的额外逻辑
      this.resolveQuestion(question)

      this.initIdentifyImages(images)

      this.initReport(data.analysis.report)

      this.initProductTitleAndImg(data.detail)
      comment(0)
    })

    // 监听清洗数据
    window.Jockey.on('resetData', (_payload, comment) => {
      this.clearData()
      this.$nextTick(() => {
        comment('success')
      })
    })
  },

  methods: {
    // 数据清洗
    clearData() {},
    // 鉴别商品
    initRegularResult(question, questionReason) {
      if (this.$t('resultMap')[question]) {
        this.identifyResults = this.$t('resultMap')[question]
      } else {
        this.identifyResults.resultIcon =
          'https://cdn.poizon.com/node-common/ZmFpbDE1OTE5NDIyMzA1Mjk=.png'
        this.identifyResults.iconTip = this.identifyResults.resultTitle =
          questionReason || ''
      }
    },
    resolveQuestion(question) {
      this.isNotRevoked = question !== 5
      this.isShowproblem = question === 2 || question === 3
    },
    // 初始化问题展示
    initReport(report) {
      if (report) {
        this.report = report
      }
    },
    // 初始化时间和鉴别商品的标题
    initProductTitleAndImg(product) {
      this.beIdentifyProduct = product
    },
    // 初始化鉴定图片的
    initIdentifyImages(images) {
      this.images = (images || []).map((v) => v.url)
    },
    seeContentImg(index) {
      Jockeys.previewImages(index, this.images)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './app-detail.scss';
</style>
